import React, { useState }  from 'react';
import './Interests.css';
import { useMsal } from '@azure/msal-react';
export default function Interests() {
    const [menuVisible, setMenuVisible] = useState(false);

    const user = {
        name: 'Sainath',
        profileImage: 'https://via.placeholder.com/40',
      };
      const toggleMenu = () => {
        setMenuVisible(!menuVisible);
      };
      const { instance } = useMsal();

        const handleLogout = () => {
                instance.logoutRedirect({
                    postLogoutRedirectUri: "/",
                });
        }
      return (
        <div className="outer-container">
          <div className="user-profile" onClick={toggleMenu}>
        <img src="profile.jpeg" alt="Profile" className="profile-image" />
        <span className="username">{user.name}</span>
        {menuVisible && (
          <div className="profile-menu">
            <button className="menu-button">Profile</button>
            <button className="menu-button" onClick={handleLogout}>Logout</button>
          </div>
        )}
      </div>
          <div className="container">
            <h2>Let’s Get Started 🎉</h2>
            <h3>Fill out the form below to help us personalize your learning experience.</h3>
            <form>
              <div className="form-group">
                <label htmlFor="fullName">User Name</label>
                <input type="text" id="fullName" placeholder="User Name" required />
              </div>
              <div className="form-group">
                <label htmlFor="Role">Role</label>
                <input type="text" id="text" placeholder="Current Job Role" required />
              </div>
              <div className="form-group">
                <label htmlFor="experience">Experience</label>
                <textarea id="experience" placeholder="Experience" />
              </div>
              <button type="submit" className="submit-button">Submit</button>
            </form>
          </div>
        </div>
      );
}